<template>
  <div class="block">
    <!-- Name -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Name</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.name"
          placeholder="請輸入名字"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Company -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Company</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.company"
          placeholder="請輸入公司"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Email -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Email</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.email"
          :rules="emailRules"
          placeholder="請輸入電子信箱"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Title -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Title</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.title"
          placeholder="請輸入職稱"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Type -->
    <div class="form-item py-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Type</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <h4 class="mb-5">國內法人</h4>
        <v-radio-group v-model="shareholderEmail.type" row>
          <div
            v-for="item in typeOptions.internalCorporatePerson"
            :key="item.value"
            class="w-33 mb-10px"
          >
            <v-radio :value="item.value">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ item.label }}
                </div>
              </template>
            </v-radio>
          </div>
        </v-radio-group>

        <h4 class="mb-5 mt-10px">國外法人</h4>
        <v-radio-group v-model="shareholderEmail.type" row>
          <div
            v-for="item in typeOptions.foreignCorporatePerson"
            :key="item.value"
            class="w-33"
          >
            <v-radio :value="item.value">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ item.label }}
                </div>
              </template>
            </v-radio>
          </div>
        </v-radio-group>

        <h4 class="my-5">一般</h4>
        <v-radio-group v-model="shareholderEmail.type" row>
          <div
            v-for="item in typeOptions.general"
            :key="item.value"
            class="w-33"
          >
            <v-radio :value="item.value">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ item.label }}
                </div>
              </template>
            </v-radio>
          </div>
        </v-radio-group>
      </div>
    </div>
    <!-- Mobile -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Mobile</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.phone"
          placeholder="請輸入手機號碼"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Tel -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Tel</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.tel"
          placeholder="請輸入聯絡電話"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Fax -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Fax</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.fax"
          placeholder="請輸入傳真密碼"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Address -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Address</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEmail.address"
          placeholder="請輸入地址"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Unsubscribe -->
    <label class="form-item py-5 d-flex">
      <div class="w-240px mr-5">
        <h4>Unsubscribe</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <button
          v-if="shareholderEmail.is_subscribe == 0"
          class="btn btn-outlined"
          :style="{
            width: '117px',
          }"
          @click="setSubscribeStatus(true)"
        >
          Subscribe
        </button>
        <button
          v-else
          class="btn btn-outlined danger-500--text"
          :style="{
            border: '1px solid #f60000',
            width: '117px',
          }"
          @click="setSubscribeStatus(false)"
        >
          Unsubscribe
        </button>
      </div>
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    typeOptions: {
      internalCorporatePerson: [
        {
          label: '投信',
          value: 2,
        },
        {
          label: '證券',
          value: 3,
        },
        {
          label: '自營商',
          value: 4,
        },
        {
          label: '銀行',
          value: 5,
        },
        {
          label: '壽險',
          value: 6,
        },
      ],
      foreignCorporatePerson: [
        {
          label: '分析師',
          value: 7,
        },
        {
          label: '經理人',
          value: 8,
        },
        {
          label: '銷售員',
          value: 9,
        },
      ],
      general: [
        {
          label: '股東',
          value: 1,
        },
      ],
    },
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'E-mail must be valid',
    ],
  }),
  computed: {
    ...mapState('shareholderEmail', ['shareholderEmail']),
  },
  methods: {
    setSubscribeStatus(status) {
      if (status === true) {
        this.shareholderEmail.is_subscribe = 1;
      } else {
        this.shareholderEmail.is_subscribe = 0;
      }
    },
  },
};
</script>

<style></style>
